export default __webpack_public_path__ + "static/media/76-mobile.2f9fe902.jpg";